import { Typography } from "@circle-react-uikit/Typography";

interface TitleProps {
  title: string;
}

export const Title = ({ title }: TitleProps) => (
  <Typography.LabelLg weight="semibold">
    <span className="text-lg" data-testid="paywall-title">
      {title}
    </span>
  </Typography.LabelLg>
);
